/**
 * Created by zuozhuo on 2018/1/25.
 */
import pathToRegexp from "path-to-regexp";
import querystring from "querystring";
import utils from "../utils/utils";
import { URL_HASH_KEYS } from "../consts/consts";

class ReactRouterUrl {
  constructor(options) {
    this.options = options;
    this.formatPath = pathToRegexp.compile(this.options.path);
    this.pushMe = this.pushMe.bind(this);
    this.replaceMe = this.replaceMe.bind(this);
  }

  getPath() {
    return this.options.path;
  }

  getComponent() {
    return this.options.component;
  }

  formatUrl(params = {}, query = {}) {
    let _url = this.formatPath(params);
    if (query) {
      // 这里加个时间戳, 因为微信下回退的时候, 老是有缓存, 在nginx上搞不定
      query[URL_HASH_KEYS.HTML_CACHE_HASH] = new Date().getTime();
      _url += `?${querystring.encode(query)}`;
    }
    return _url;
  }

  pushMe(params = {}, query) {
    return utils.pushUrl(this.formatUrl(params, query));
  }

  replaceMe(params = {}, query) {
    return utils.replaceUrl(this.formatUrl(params, query));
  }
}

export default ReactRouterUrl;



// WEBPACK FOOTER //
// ./src/router/ReactRouterUrl.js